import styled from 'styled-components';
import media from 'styles/media';
import { SecondaryButton } from 'styles/elements/buttons/primaryCare';
import { Div, ColumnDiv } from 'styles/elements/div';
import { H1 } from 'styles/elements/headers';
import { Caret } from 'assets/primaryCare/icons';

const Card = styled(ColumnDiv)`
  flex: 1 1 auto;
  background: ${props => props.theme.backgroundColorPrimary};
`;

const Inner = styled(Card)`
  ${media.smallAndBelow`
    padding: 0;
  `}
`;

const FlexRow = styled(Div)`
  flex: 1 1 auto;
`;

const CardContents = styled(Div)`
  overflow-y: ${props => (props.isMounted ? 'auto' : 'hidden')};
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  position: relative;
  padding-bottom: 10px;
  flex: 1 1 auto;
  ${media.IE9 ? `
    height: 600px;
  ` : ''}
  ${props => props.theme.forceScrollBarStyles};
`;

const ButtonSmall = styled(SecondaryButton)`
  border: none;
  margin: 0;
  display: flex;
  padding: ${props => props.theme.buttonPadding};
  color: ${props => props.theme.anchorColor};
  align-items: center;
  font-family: ${props => props.theme.fontFamilyButton};;
  background: ${props => props.theme.backgroundColorPrimary};
  ${media.smallAndBelow`
    padding: ${props => props.theme.buttonPaddingSmall};;
  `}
`;

const Footer = styled(Div)`
  background: ${props => props.theme.backgroundColorPrimary};
  border-top: ${props => (props.isSetToTop ? 'none' : `1px solid ${props.theme.borderColor}`)};
  min-height: 30px;
  box-sizing: border-box;
  padding: ${props => props.theme.footerPadding};
  padding-top: ${props => (props.isSetToTop ? '7px' : '10px')};
  margin-left: 1px;
  justify-content: space-between;
  ${media.smallAndBelow`
    padding: 7px 3.5%;
  `}
`;

const PrevCaret = styled(Caret)`
  fill: ${props => props.theme.prevCaretFill};
  transform: ${props => (props.theme.prevCaretTransform ? props.theme.prevCaretTransform : props.transform)};
  height: ${props => props.theme.prevCaretSize};
  width: ${props => props.theme.prevCaretSize};
  margin-right: 10px;
`;

const HomeIcon = styled.div`
  height: 35px;
  line-height: 35px;
  :after {
    content: '\\e800';
    font-family: "fontello-kiosk", Arial, sans-serif;
    display: inline-block;
    width: 1em;
    margin: 0 0.2em;
  }
`;

const BackIcon = styled(HomeIcon)`
  :after {
    content: '\\e801';
    font-family: "fontello-kiosk", Arial, sans-serif;
    margin-left: -4px;
  }
`;

const HomeText = styled.div`
  margin-left: 15px;
`;

const BackText = styled.div`
  margin-left: 0.25em;
  margin-right: 0.02em;
`;

const Header = styled(H1)`
  margin-left: ${props => `${props.theme.paddingPercentageHorizontalLargeScreen}%`};
  margin-bottom: 0;
  ${media.extraSmallAndBelow`
    font-size: 18px;
  `}
`;

Card.CardContents = CardContents;
Card.Inner = Inner;
Card.ButtonSmall = ButtonSmall;
Card.Footer = Footer;
Card.FlexRow = FlexRow;
Card.PrevCaret = PrevCaret;
Card.Header = Header;
Card.HomeIcon = HomeIcon;
Card.HomeText = HomeText;
Card.BackIcon = BackIcon;
Card.BackText = BackText;

export default Card;
